import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import InstallMobileOutlinedIcon from '@mui/icons-material/InstallMobileOutlined';

import { usePwaInstall } from './usePwaInstall';

export default function InstallAppButton({ size = 'small' }) {
  const { canInstall, promptInstall } = usePwaInstall();

  if (!canInstall) return null;

  return (
    <Tooltip title="Install UpRyzze">
      <IconButton
        size={size}
        aria-label="Install UpRyzze"
        onClick={() => {
          promptInstall();
        }}
        sx={{ color: 'text.secondary' }}
      >
        <InstallMobileOutlinedIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
}
